import React from "react";
import Main from "./pages";
import CacheBuster from "react-cache-buster";
import { version } from "../package.json";
import { initializeApp } from "firebase/app";
import "fontsource-roboto";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

const App = () => {
  const isProduction = process.env.NODE_ENV === "production";
  initializeApp(firebaseConfig); // Initialize Firebase

  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction}
      isVerboseMode={false}
    >
      <Main />
    </CacheBuster>
  );
};

export default App;
